interface ErrorLikeWithStatus {
  status?: unknown;
  code?: unknown;
  message?: unknown;
  name?: unknown;
  isAxiosError?: unknown;
  response?: {
    status?: unknown;
  };
  request?: unknown;
}

export class ApiResponseError extends Error {
  status: number;

  constructor(status: number, message = 'API request failed') {
    super(message);
    this.name = 'ApiResponseError';
    this.status = status;
  }
}

export const getApiErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const errorLike = error as ErrorLikeWithStatus;
  if (typeof errorLike.status === 'number') {
    return errorLike.status;
  }

  if (typeof errorLike.response?.status === 'number') {
    return errorLike.response.status;
  }

  return undefined;
};

const isNetworkError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const errorLike = error as ErrorLikeWithStatus;
  if (errorLike.isAxiosError === true && !errorLike.response) {
    return true;
  }

  if (typeof errorLike.code === 'string') {
    return ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(errorLike.code);
  }

  return errorLike.name === 'TypeError' && typeof errorLike.message === 'string';
};

export const getUserFacingApiErrorMessage = (error: unknown): string => {
  const status = getApiErrorStatus(error);

  if (status === 400) {
    return 'リクエスト内容に問題があります。入力内容を確認して再試行してください。';
  }

  if (status === 401) {
    return 'ログイン状態を確認できませんでした。再度ログインしてください。';
  }

  if (status === 403) {
    return 'この操作を行う権限がありません。';
  }

  if (status === 404) {
    return '対象のデータが見つかりませんでした。';
  }

  if (status === 413) {
    return 'ファイルサイズが大きすぎます。サイズを確認して再試行してください。';
  }

  if (status === 429) {
    return 'リクエストが集中しています。少し時間をおいて再試行してください。';
  }

  if (status !== undefined && status >= 500) {
    return 'サーバー側で問題が発生しました。時間をおいて再試行してください。';
  }

  if (isNetworkError(error)) {
    return 'サーバーに接続できません。ネットワーク接続を確認して再試行してください。';
  }

  return '処理中にエラーが発生しました。時間をおいて再試行してください。';
};
